export default __webpack_public_path__ + "static/media/logo_full_trans.22029f3a.png";